import { useEffect, useState } from "react"
import { useAuth } from "../hooks/useAuth"
import { getUserDeviceTokens } from "../services/userService"
import { GET_CHAPERON_APP_URL } from "../const/paths"
import PromoBanner from "./PromoBanner"

/**
 * Lifecycle banner promoting the mobile app, shown only to a signed-in user
 * with no registered device (a device token means the app is installed, the
 * same signal the web location sync uses). Hidden while that is unknown or
 * if the check fails, so it never flashes up for someone who has the app.
 */
export default function MobileAppBanner() {
    const isLoggedIn = useAuth()
    const [hasMobileApp, setHasMobileApp] = useState(null)

    useEffect(() => {
        if (!isLoggedIn) return

        let cancelled = false
        getUserDeviceTokens()
            .then((result) => {
                if (!cancelled) setHasMobileApp((result?.data?.length ?? 0) > 0)
            })
            .catch(() => {})

        return () => {
            cancelled = true
        }
    }, [isLoggedIn])

    if (!isLoggedIn || hasMobileApp !== false) return null

    return (
        <PromoBanner
            icon="bi-download"
            title="Go mobile..."
            href={GET_CHAPERON_APP_URL}
        >
            Take Chaperon with you. The app shares your location with your
            community, reminds you to check in on Checker trips, and alerts you
            the moment someone needs you.
        </PromoBanner>
    )
}
